export let life = {
  async created () {
    this.methods('checkPageSize') // 检查网页可视区域大小
    this.methods('toLogin') // 如果没有sessionID或者sessionID过期就跳转到登录页
    this.methods('removeWellCome')
  },
  mounted () {
  }
}
export let event = {
  async logOut(){
    let confirm = undefined
    try{
      confirm = await this.$confirm('确定登出系统？', '登出确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      });
    }catch(e){

    }
    if (confirm === 'confirm') {
      this.methods('logOut')
    }
  }
}
export let watch = {
  '$route.name':function () {
    document.title = window.CONFIG.TITLE
  }
}
